import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.ManualJournalLines', {
    sectionHeader: 'Line Items',
    amountsAre: 'Amounts are',
    numberColName: '#',
    accountColName: 'Account',
    debitColName: 'Debit',
    creditColName: 'Credit',
    descriptionColName: 'Description',
    taxRateColName: 'Tax Rate',
    taxAmountColName: 'Tax Amount',
    defaultInputPlaceholder: 'Enter value',
    defaultSelectPlaceholder: 'Select value',
});
